import React, { useEffect, useRef, useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Text,
  Flex,
  HStack,
  FormLabel,
  Input,
  useRadioGroup,
  FormControl,
  Heading,
  FormHelperText,
  Tooltip,
  Button,
  Icon,
  useDisclosure,
  Textarea,
  Box,
} from "@chakra-ui/react";
import { ToastContainer, toast } from "react-toastify";
import { FaStar, FaRegStar } from "react-icons/fa";
import { RadioCard } from "./RadioOption";
import { ActionButton, PayButton } from "./DynamicButton";
import FadeIn from "react-fade-in/lib/FadeIn";
import DynamicInput from "./DynamicInput";
import DynamicSelectInput from "./DynamicSelect";
import {
  getTemplateActionWord,
  getTemplatePledgeWord,
} from "../../utils/templateWords";
import { Checkbox } from "@chakra-ui/react";
import { checkboxAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";
import { MdVerified, MdDateRange, MdSwapHoriz } from "react-icons/md";
import { HiPlusCircle } from "react-icons/hi";
import { CloseIcon, DeleteIcon, EditIcon } from "@chakra-ui/icons";
import PledgePopUp from "./PledgePopUp";
import { checkPledge, checkSub } from "../../utils/api";
import { NOT_REGISTERED_MESSAGE, titleCase } from "../../utils/functions";
import SubPopUp from "./SubPopUp";
import OptionsWithCheckboxes from "./OptionsWithCheckboxes";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(checkboxAnatomy.keys);

const baseStyle = definePartsStyle({
  control: {
    padding: 30,
    borderRadius: 0,
  },
});

export const checkboxTheme = defineMultiStyleConfig({ baseStyle });

const DynamicDrawer = React.memo(
  ({
    placement = "bottom",
    isOpen,
    onClose,
    isCentered,
    subActive,
    payLink,
    data,
    colorMain,
    amount,
    setAmount,
    mpesa,
    number,
    phoneLength,
    name,
    setName,
    setRecurring,
    recurring,
    disabled,
    selection,
    setSelection,
    buttone,
    buttonDisable,
    trigger,
    handlePayment,
    nameOption,
    handleInput,
    contributionMode,
    setOpening,
    pledgeNumber,
    customerName,
    setCustomerName,
    isRegisteredMember,
    isRegisteredPledgeMember,
    registeredOnly,
    pledgeAmount,
    setPledgeAmount,
    handlePledgeContribution,
    handleInputPledge,
    setPhoneLength,
    setPledgeNumber,
    setNumber,
    buttonText,
    selectedOption,
    enteredAmount,
    urlOptions,
    setPayType,
    payType,
    paymentData,
    setOtherDetails,
    setSelectionDetails,
    selectedTarget,
    trackCode,
    saleId,
    defaultOptions,
    memberPay,
    subscribeData,
    sales_code,
    org_id,
    isApiAmount,
    isItemSelected,
    urlOption,
  }) => {
    const trimmedNumber = (number || "").trim();
    const isNumberPhoneLike = /^\d+$/.test(trimmedNumber);
    const isNumberReadyForRegisteredCheck = isNumberPhoneLike
      ? trimmedNumber.length === phoneLength
      : trimmedNumber.length >= 4;

    const templateType =
      data?.data.saledata?.sale_settings?.template_type || "default";

    // Welfare and chama templates don't offer the anonymous / recurring checkbox
    const hideAnonymousOption = ["welfare", "chamas"].includes(templateType);

    const idtagRequired = data?.data.saledata?.sale_settings?.idtag_required;
    const idtagLabel = data?.data.saledata?.sale_settings?.idtag_label || "ID Tag";
    const nameParts = (name || "").split("#");
    const baseName = nameParts.length > 1 ? nameParts.slice(0, -1).join("#").trim() : (nameParts[0] || "");
    const idTag = nameParts.length > 1 ? nameParts[nameParts.length - 1].trim() : "";

    let detailTo =
      data?.data?.saledata?.sale_settings?.pay_detail_type || false;
    // let detailTo = "options";

    let phoneButtonConfig = null;
    const phoneButtonLabelRaw = data?.data?.saledata?.sale_settings?.phone_button_label;
    if (phoneButtonLabelRaw) {
      try {
        phoneButtonConfig = JSON.parse(phoneButtonLabelRaw);
      } catch (e) {
        phoneButtonConfig = null;
      }
    }

    const getActionWord = getTemplateActionWord;

    // Word used instead of "pledge" for this template, e.g. "Contribution Due"
    const pledgeWord = titleCase(getTemplatePledgeWord(templateType));

    const initialRef = useRef();
    const testRef = useRef();
    const [isChecked, setIsChecked] = useState(false);
    const [cardPayment, setCardPayment] = useState(false);
    const [currencyMode, setCurrencyMode] = useState("BASE");

    const multicurrencySetting = data?.data?.saledata?.sale_settings?.multicurrency;
    const [baseCurrency, targetCurrency, conversionRate] = multicurrencySetting
      ? multicurrencySetting.split("#")
      : [null, null, null];

    const canSwitchCurrency =
      baseCurrency && targetCurrency && conversionRate;
    const [counter, setCounter] = useState(0);
    const [totalSplitAmount, setTotalSplitAmount] = useState(0);
    const [quantity, setQuantity] = useState(1);

    const [pledge, setPledge] = useState(0);
    const [memberSub, setMemberSub] = useState(false);
    const [isSubLoading, setIsSubLoading] = useState(false);

    let cardOption = true;
    const [isPledgeOpen, setIsOpenPledge] = useState(false);
    const [isSubOpen, setIsOpenSub] = useState(false);
    const [isPopped, setIsPopped] = useState(false);
    const subAmount = data?.data.saledata?.sale_settings?.subscribe_amount || 0;

    const [inputs, setInputs] = useState([]);
    const [isAddButtonDisabled, setIsAddButtonDisabled] = useState(false);
    const [isSelectButtonDisabled, setIsSelectButtonDisabled] = useState(false);
    const [totalSplitAmountB, setTotalSplitAmountB] = useState(0);
    const [isCheckedAanyChecked, setAnyChecked] = useState(false);

    useEffect(() => {
      number?.length === phoneLength &&
        parseInt(subAmount) > 0 &&
        memberPay &&
        inputs.length === 0 &&
        checkFilter();
    }, [number]);

    let checkFilter = async () => {
      setIsSubLoading(true);
      const subResult = await checkSub(number, sales_code);
      if (subResult.success && subResult.paid) {
        setMemberSub(subResult.paid);
      } else {
        setMemberSub(false);
      }
      setIsSubLoading(false);
      memberPay && !memberSub && setIsOpenSub(true);
    };
    useEffect(() => {
      const check = async () => {
        if (name && name.length > 2 && inputs.length === 0) {
          const pledgeResult = await checkPledge(saleId, name);
          if (pledgeResult.success) {
            setPledge(pledgeResult.pledge);
          } else {
            setPledge(0);
          }
        }
      };
      check();
    }, [name]);

    const addInput = () => {
      setCounter((prevCounter) => prevCounter + 1);
      setInputs((prevInputs) => [...prevInputs, { name: "", amount: "" }]);
    };

    const handleInputChange = (e, index, type) => {
      const { value } = e.target;
      let updatedInputs = [...inputs];

      let intValue = parseInt(value, 10);

      // Update the input value
      updatedInputs[index] = {
        ...updatedInputs[index],
        [type]: type === "amount" ? intValue : value,
      };

      // Calculate the total amount
      const totalAmount = updatedInputs.reduce((sum, input) => {
        return sum + (parseFloat(input.amount) || 0);
      }, 0);

      if (totalAmount <= amount - 1) {
        setInputs(updatedInputs);
        setTotalSplitAmount(totalAmount);
      } else {
        toast.warning(
          "Total split amount must not exceed the amount threshold!"
        );
      }
    };

    useEffect(() => {
      setOtherDetails(inputs);
    }, [inputs]);

    useEffect(() => {
      pledge > 0 && !isPopped && setIsOpenPledge(true) && setIsPopped(true);
    }, [pledge]);

    useEffect(() => {
      const isAnyInputNotFilled = inputs.some(
        (input) => !input.name || !input.amount
      );

      setIsAddButtonDisabled(isAnyInputNotFilled);
    }, [inputs]);

    const removeInput = (index) => {
      setIsAddButtonDisabled(false);
      setCounter((prevCounter) => prevCounter - 1);
      setInputs((prevInputs) => prevInputs.filter((_, i) => i !== index));
    };

    useEffect(() => {
      const handleResize = () => {
        const viewport = document.querySelector("meta[name=viewport]");
        const initialHeight = window.innerHeight;

        if (window.innerHeight < initialHeight) {
          // Soft keyboard is open, add scroll to the page
          document.documentElement.style.overflow = "auto";

          // Reset the height in meta viewport with the initial height of the page
          viewport.setAttribute(
            "content",
            `height=${initialHeight}px, width=device-width, initial-scale=1.0`
          );
        } else {
          // Soft keyboard is closed, reset meta viewport
          viewport.setAttribute(
            "content",
            "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
          );
        }
      };

      window.addEventListener("resize", handleResize);

      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }, []);

    const option = ["mpesa", "card"];

    const { getRootProps, getRadioProps } = useRadioGroup({
      name: "options",
      value: payType,
    });

    const handleChange = (value) => {
      if (value === "card" && !cardPayment) {
        toast.warning(
          "Organizers have not enabled card payments for this collection, contact them to enable if you prefer to pay with a card"
        );
        return;
      }
      setPayType(value);
    };

    const group = getRootProps();

    const [amountBlank, setAmountBlank] = useState(true);
    const [onPayClick, setOnPayClick] = useState(false);

    useEffect(() => {
      if (onPayClick || amount) {
        if (amount > 0) {
          setAmountBlank(false);
        } else {
          setAmountBlank(true);
          initialRef?.current?.focus();
          toast.warning(`Please enter amount!`);
        }
      } else {
        setAmountBlank(true);
      }
    }, [onPayClick, amount]);

    useEffect(() => {
      setCardPayment(
        paymentData?.find((payment) => payment?.link_type === "CARD")
      );
    }, [paymentData]);

    const targetsJson =
      data?.data?.saledata?.sale_settings?.pay_details_targets;

    // Replace single quotes with double quotes to make the JSON valid
    const processedJson = targetsJson?.replace(/'/g, '"');

    let targets;
    try {
      const parsed = JSON.parse(processedJson);
      targets = parsed?.isInternalTargets ? [] : (parsed?.targets || []);
    } catch (error) {
      // console.error("Error parsing JSON:", error);
      targets = [];
    }

    // State to track selected target
    const [selectedTargets, setSelectedTargets] = useState(null);

    useEffect(() => {
      if (
        selection &&
        detailTo &&
        detailTo !== "text" &&
        templateType !== "tickets"
      ) {
        const selectedTarget = targets.find(
          (target) => target.name === String(selection).split("#")[0]
        );
        setSelectedTargets(selectedTarget || null);
      } else {
        setSelectedTargets(null);
      }
    }, [selection, targets]);

    useEffect(() => {
      if (
        selectedTargets &&
        selectedTargets.amount > 0 &&
        detailTo &&
        detailTo !== "text" &&
        templateType !== "tickets"
      ) {
        const isQuantityVisible = data?.data?.saledata?.sale_settings?.quantity_button_visible === true;
        const multiplier = isQuantityVisible ? quantity : 1;
        const totalAmount = selectedTargets.amount * multiplier;

        contributionMode === "pay" && setAmount(totalAmount || "");
        contributionMode === "pledge" &&
          setPledgeAmount(
            totalAmount
              ? totalAmount
              : pledgeAmount > 0
                ? pledgeAmount
                : ""
          );
      }
    }, [selectedTargets, quantity]);

    // Subcategories: selection is stored as "category" or "category#subcategory"
    const selectedCategory = selection ? String(selection).split("#")[0] : "";
    const selectedSubCategory = selection
      ? String(selection).split("#").slice(1).join("#")
      : "";
    const subCategoryOptions = (
      urlOptions?.find((opt) => opt?.value === selectedCategory)
        ?.subCategories || ""
    )
      .split(",")
      .map((sub) => sub.trim())
      .filter(Boolean)
      .map((sub) => ({ value: sub }));
    const needsSubCategory =
      subCategoryOptions.length > 0 && !selectedSubCategory;
    const renderSubCategorySelect = () =>
      subCategoryOptions.length > 0 ? (
        <>
          <FormLabel fontSize="lg" fontWeight="medium" color="gray.600" mt={2}>
            &nbsp; Subcategory
          </FormLabel>
          <DynamicSelectInput
            mb={8}
            options={subCategoryOptions}
            value={selectedSubCategory}
            placeholder="Select a subcategory"
            onChange={(e) =>
              setSelection(`${selectedCategory}#${e.target.value}`)
            }
            isDisabled={selectedOption}
          />
        </>
      ) : null;

    // Pledge / payment due notice and popup. Rendered outside the amount
    // section so it also shows when that section is hidden (priced options).
    const pledgeNotice = (
      <>
        {pledge > 0 && (
          <Flex
            p={0}
            pb={2}
            m={0}
            alignItems="center"
            justifyContent="center"
          >
            <FormHelperText
              p={0}
              m={0}
              fontSize="xl"
              fontWeight="bold"
            >
              You have a {pledgeWord?.toLowerCase()} of{" "}
              <span style={{ color: "red" }}>
                KES {pledge}
              </span>
            </FormHelperText>
          </Flex>
        )}
        {pledge > 0 && !isPopped && (
          <PledgePopUp
            isPledgeOpen={isPledgeOpen}
            setIsOpenPledge={setIsOpenPledge}
            pledge={pledge}
            setAmount={setAmount}
            pledgeWord={pledgeWord}
          />
        )}
      </>
    );

    return (
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        isCentered={true}
        initialFocusRef={initialRef}
        closeOnOverlayClick={trigger ? false : true}
        size="md"
      >
        <ToastContainer />
        <ModalOverlay />
        {contributionMode === "pay" ? (
          <>
            {payLink === undefined ||
              (!subActive && (!memberPay || parseInt(subAmount) < 1)) ? (
              <ModalContent mb="300">
                <ModalCloseButton />
                <ModalBody p={9} fontSize="xl">
                  <Text>
                    Plan for this collection is not active. The plan has expired
                    or number of contibutors has been exceeded. Contact the
                    organizer to renew or upgrade the plan. We apologize for the
                    inconvenience.
                  </Text>
                </ModalBody>
              </ModalContent>
            ) : (
              <>
                <ModalOverlay />
                <ModalContent borderTopRadius="2xl" fontFamily="'Poppins', sans-serif">
                  <ModalCloseButton />
                  <ModalHeader mt={3} textAlign="center" color={colorMain}>
                    Click to switch mode of payment
                    <Flex
                      alignItems="center"
                      pt={3}
                      pb={0}
                      justifyContent="center"
                    >
                      <HStack
                        {...group}
                        variant="outline"
                        outline={`.0082rem solid #bbbbbb`}
                        shadow="base"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        w="100%"
                        height="36px"
                        pt={0}
                        borderRadius="md"
                        px={0}
                        position="relative"
                      >
                        {option.map((value) => {
                          const radio = getRadioProps({ value });
                          return (
                            <RadioCard
                              isDisabled={trigger}
                              key={value}
                              {...radio}
                              onChange={() => handleChange(value)}
                            >
                              {value === "mpesa"
                                ? (phoneButtonConfig?.mpesaLabel || "MPESA")
                                : (phoneButtonConfig?.cardLabel || "CARD")}
                            </RadioCard>
                          );
                        })}
                      </HStack>
                    </Flex>
                  </ModalHeader>
                  <ModalBody pb={0} color={colorMain}>
                    {detailTo === "options" &&
                      amount < 1 &&
                      urlOptions &&
                      urlOptions?.some((option) => option.target > 0) ? (
                      <FormControl>{pledgeNotice}</FormControl>
                    ) : (
                      <FormControl>
                        {(() => {
                          const displayAmount =
                            currencyMode === "BASE"
                              ? amount
                              : amount
                                ? Math.round(amount * parseFloat(conversionRate))
                                : "";

                          const displayLength = String(displayAmount || "")
                            .length;
                          const amountFontSize =
                            displayLength > 12
                              ? "2xl"
                              : displayLength > 9
                                ? "4xl"
                                : displayLength > 6
                                  ? "5xl"
                                  : "7xl";

                          return (
                            <Flex
                              // shadow="base"
                              borderRadius="10px"
                              flexDir="column"
                              px={3}
                              pt={4}
                              height="fit-content"
                            >
                              <Text
                                fontWeight="bold"
                                fontSize="lg"
                                pb={0}
                                mb={0}
                              >
                                Enter Amount
                              </Text>
                              <Flex
                                pb={amountBlank ? 0 : 2}
                                alignItems="baseline"
                                ml={
                                  !amount || amount?.length < 1
                                    ? "12"
                                    : amount?.length > 4
                                      ? amount?.length - 2
                                      : "16"
                                }
                                justifyContent="center"
                                fontWeight="semibold"
                              >
                                {canSwitchCurrency ? (
                                  <Button
                                    size="sm"
                                    onClick={() =>
                                      setCurrencyMode((mode) =>
                                        mode === "BASE" ? "TARGET" : "BASE"
                                      )
                                    }
                                    variant="ghost"
                                    mr={2}
                                    color="#878787"
                                    fontSize="18px"
                                    fontWeight="lighter"
                                    px={0}
                                    _hover={{ bg: "transparent" }}
                                    rightIcon={<MdSwapHoriz />}
                                  >
                                    {currencyMode === "BASE"
                                      ? baseCurrency
                                      : targetCurrency}
                                  </Button>
                                ) : (
                                  <span
                                    style={{
                                      color: "#878787",
                                      fontWeight: "lighter",
                                      fontSize: "18px",
                                      marginRight: "3px",
                                    }}
                                  >
                                    KES
                                  </span>
                                )}
                                <Input
                                  ref={
                                    selectedTargets?.amount > 0
                                      ? testRef
                                      : initialRef
                                  }
                                  type="number"
                                  variant="unstyled"
                                  fontSize={[amountFontSize, amountFontSize]}
                                  placeholder={
                                    !amount || amount < 1 ? "0.00" : ""
                                  }
                                  value={displayAmount}
                                  isReadOnly={
                                    enteredAmount || isApiAmount || isItemSelected || selectedTargets?.amount > 0
                                  }
                                  onChange={(e) => {
                                    const val = e.target.value;
                                    if (currencyMode === "BASE") {
                                      setAmount(val);
                                    } else {
                                      if (val) {
                                        setAmount(
                                          Math.round(
                                            parseFloat(val) /
                                            parseFloat(conversionRate)
                                          )
                                        );
                                      } else {
                                        setAmount("");
                                      }
                                    }
                                  }}
                                  required
                                  color={colorMain}
                                  fontWeight="semibold"
                                  borderRadius="md"
                                  _focus={{
                                    borderColor: "teal.500",
                                    boxShadow: "none",
                                  }}
                                />
                              </Flex>
                              {canSwitchCurrency && amount > 0 && (
                                <Text
                                  fontSize="lg"
                                  color="gray.600"
                                  textAlign="center"
                                  fontWeight="bold"
                                  mt={-2}
                                  mb={2}
                                >
                                  ≈{" "}
                                  {currencyMode === "BASE"
                                    ? `${Math.round(
                                      amount * parseFloat(conversionRate)
                                    )} ${targetCurrency}`
                                    : `${Math.round(
                                      parseFloat(amount)
                                    )} ${baseCurrency}`}
                                </Text>
                              )}
                              {amountBlank && (
                                <Flex
                                  p={0}
                                  pb={2}
                                  m={0}
                                  alignItems="center"
                                  justifyContent="center"
                                >
                                  <FormHelperText
                                    p={0}
                                    m={0}
                                    color="red"
                                    fontSize="sm"
                                  >
                                    Amount must be greater than 0.
                                  </FormHelperText>
                                </Flex>
                              )}
                              {defaultOptions &&
                                templateType !== "tickets" &&
                                defaultOptions?.length > 0 && (
                                  <Flex
                                    alignItems="center"
                                    justifyContent="center"
                                    gap={12}
                                  >
                                    {defaultOptions?.map(
                                      (defaultAmount, index) => (
                                        <Button
                                          key={index}
                                          value={defaultAmount}
                                          px={5}
                                          borderRadius={12}
                                          color={
                                            amount === defaultAmount
                                              ? "white"
                                              : `${colorMain}`
                                          }
                                          bg={
                                            amount === defaultAmount
                                              ? `${colorMain}`
                                              : "gray.200"
                                          }
                                          fontSize="lg"
                                          onClick={(e) => {
                                            setAmount(e.target.value);
                                          }}
                                        >
                                          {defaultAmount}
                                        </Button>
                                      )
                                    )}
                                  </Flex>
                                )}
                              {memberPay && !memberSub && isSubOpen && (
                                <SubPopUp
                                  isSubOpen={isSubOpen}
                                  setIsOpenSub={setIsOpenSub}
                                  subAmount={subAmount}
                                  number={number}
                                  subscribeData={subscribeData}
                                  sales_code={sales_code}
                                  name={name || "anonymous"}
                                  toast={toast}
                                  isSubLoading={isSubLoading}
                                  setMemberSub={setMemberSub}
                                  org_id={org_id}
                                  setIsSubLoading={setIsSubLoading}
                                />
                              )}

                              {pledgeNotice}
                            </Flex>
                          );
                        })()}
                      </FormControl>

                    )}
                    {/* {amount && ( */}
                    <FadeIn>
                      <FormControl isRequired fontSize="xl" mt={10}>
                        <FormLabel fontSize="lg" fontWeight="medium" color="gray.600">
                          &nbsp; {payType === "card"
                            ? phoneButtonConfig?.cardPrompt || (!phoneButtonConfig && phoneButtonLabelRaw) || "Phone number or Email"
                            : phoneButtonConfig?.mpesaPrompt || "Phone number"}
                        </FormLabel>
                        <DynamicInput
                          mb={1}
                          reff={
                            selectedTargets?.amount > 0 ? initialRef : testRef
                          }
                          type="text"
                          placeholder={
                            !number
                              ? payType === "card"
                                ? "Enter required text here"
                                : "Enter phone number"
                              : ""
                          }
                          value={number}
                          onChange={(e) => {
                            const { number, length } = handleInput(
                              e,
                              payType === "card" && cardOption
                            );
                            setNumber(number);
                            setPhoneLength(length);
                          }}
                        />
                        <FormHelperText
                          textAlign="center"
                          color="orange"
                          fontSize="sm"
                          m={0}
                          py={0}
                          mb={8}
                        >
                          {payType === "mpesa"
                            ? "A payment request shall be sent to this number"
                            : "Local card payments are charged 2.9% card processing fee by our card processor Paystack Limited"}
                        </FormHelperText>

                        {registeredOnly &&
                          isNumberReadyForRegisteredCheck &&
                          !disabled &&
                          !isRegisteredMember && (
                            <FormHelperText
                              textAlign="center"
                              color="red.500"
                              fontSize="sm"
                              m={0}
                              mb={8}
                            >
                              {NOT_REGISTERED_MESSAGE}
                            </FormHelperText>
                          )}

                        {nameOption &&
                          (payType === "card" ||
                            number?.length === phoneLength) && (
                            <FadeIn>
                              <FadeIn>
                                <FormLabel fontSize="lg" fontWeight="medium" color="gray.600">
                                  &nbsp;
                                  {data?.data.saledata?.sale_settings
                                    ?.name_label || "Name"}
                                </FormLabel>
                                <Flex
                                  shadow="base"
                                  bg="#f4f4f2"
                                  flexDir="column"
                                  p={3}
                                  py={5}
                                  mt={3}
                                >
                                  <Flex
                                    w="100%"
                                    alignItems="center"
                                    justifyContent="space-between"
                                    mb={counter > 0 && 4}
                                  >
                                    <DynamicInput
                                      w={counter > 0 ? "75%" : "100%"}
                                      type="text"
                                      placeholder={
                                        !baseName ? "Enter details here" : ""
                                      }
                                      value={isChecked ? "Anonymous" : baseName}
                                      onChange={(e) => setName(idTag ? `${e.target.value}#${idTag}` : e.target.value)}
                                      isDisabled={disabled}
                                    />
                                    {counter > 0 && (
                                      <Flex alignItems="center" w="23%">
                                        <Flex mb="12px">-</Flex>
                                        <DynamicInput
                                          value={amount - totalSplitAmount}
                                          isReadOnly="true"
                                          border="none"
                                          background="transparent !important"
                                          type="number"
                                        />
                                      </Flex>
                                    )}
                                  </Flex>
                                  {inputs.map((input, index) => (
                                    <Flex
                                      key={index}
                                      w="100%"
                                      alignItems="center"
                                      justifyContent="space-between"
                                      mb={4}
                                    >
                                      <Flex flexDir="column" w="65%">
                                        <DynamicInput
                                          value={input.name}
                                          onChange={(e) =>
                                            handleInputChange(e, index, "name")
                                          }
                                          add={true}
                                        />
                                        {!input.name && (
                                          <span className="helper-text">
                                            Name is required
                                          </span>
                                        )}
                                      </Flex>
                                      -
                                      <Flex flexDir="column" w="25%">
                                        <DynamicInput
                                          type="number"
                                          min="1"
                                          value={input.amount}
                                          onChange={(e) =>
                                            handleInputChange(
                                              e,
                                              index,
                                              "amount"
                                            )
                                          }
                                          add={true}
                                          isReadOnly={selectedOption}
                                        />
                                        {!input.amount && (
                                          <span className="helper-text">
                                            Amount
                                          </span>
                                        )}
                                      </Flex>
                                      <Text
                                        p={0}
                                        pb={2}
                                        onClick={() => {
                                          removeInput(index);
                                        }}
                                        cursor={selectedOption ? "not-allowed" : "pointer"}
                                      >
                                        <Icon as={CloseIcon} fontSize="xl" />
                                      </Text>
                                    </Flex>
                                  ))}

                                  {detailTo !== "options" &&
                                    amount > 1 &&
                                    !trigger &&
                                    (name || isChecked) && (
                                      <Flex
                                        alignItems="center"
                                        justifyContent="center"
                                        w="100%"
                                      >
                                        <Button
                                          border="1px solid black"
                                          borderColor={colorMain}
                                          alignItems="center"
                                          justifyContent="center"
                                          gap={2}
                                          fontSize="lg"
                                          fontWeight="bold"
                                          borderRadius="10px"
                                          w="fit-content"
                                          background="transparent"
                                          onClick={addInput}
                                          isDisabled={isAddButtonDisabled || selectedOption}
                                        >
                                          <Icon as={HiPlusCircle} />
                                          {getActionWord(templateType)} for
                                          someone else
                                        </Button>
                                      </Flex>
                                    )}
                                </Flex>
                              </FadeIn>
                              {idtagRequired && (
                                <FadeIn>
                                  <FormLabel fontSize="lg" fontWeight="medium" color="gray.600" mt={4}>
                                    &nbsp;{idtagLabel}
                                  </FormLabel>
                                  <Flex shadow="base" bg="#f4f4f2" flexDir="column" p={3} py={5} mt={3}>
                                    <DynamicInput
                                      w="100%"
                                      type="text"
                                      placeholder={`Enter ${idtagLabel} here`}
                                      value={isChecked ? "" : idTag}
                                      onChange={(e) => setName(e.target.value ? `${baseName}#${e.target.value}` : baseName)}
                                      isDisabled={disabled}
                                    />
                                  </Flex>
                                </FadeIn>
                              )}
                              {hideAnonymousOption ? null : !data?.data.saledata?.sale_settings
                                ?.recurring_contributions ? (
                                <Checkbox
                                  mt={3}
                                  mb={8}
                                  size="md"
                                  isChecked={isChecked}
                                  onChange={() => setIsChecked(!isChecked)}
                                >
                                  {getActionWord(templateType)} anonymously
                                </Checkbox>
                              ) : (
                                <Checkbox
                                  mb={8}
                                  size="xl"
                                  isChecked={recurring}
                                  onChange={() => setRecurring(!recurring)}
                                >
                                  Make this a{" "}
                                  {data?.data.saledata?.sale_settings
                                    ?.payment_cadence || "Recurring"}{" "}
                                  Payment
                                </Checkbox>
                              )}
                            </FadeIn>
                          )}

                        {data?.data.saledata?.sale_settings
                          ?.pay_detail_button ? (
                          detailTo && ["select", "dropdown", "multiple_choice"].includes(detailTo) ? (
                            <>
                              <FormLabel fontSize="lg" fontWeight="medium" color="gray.600" mt={2}>
                                &nbsp;{" "}
                                {data?.data.saledata?.sale_settings
                                  ?.pay_detail_button_name || "Select"}
                              </FormLabel>

                              <DynamicSelectInput
                                mb={8}
                                options={urlOptions}
                                condition={selectedOption}
                                value={selectedCategory}
                                onChange={(e) => setSelection(e.target.value)}
                                required
                                isDisabled={selectedOption}
                              />
                              {renderSubCategorySelect()}
                              {data?.data?.saledata?.sale_settings?.quantity_button_visible === true && selectedTargets && (
                                  <Flex w="100%" justifyContent="space-between" alignItems="flex-end" mt={4} mb={8} p={4} bg="gray.50" borderRadius="xl" borderTop="1px solid" borderColor="gray.200">
                                      <Flex flexDir="column">
                                          <Text fontSize="xs" fontWeight="bold" color="gray.500" mb={1} textTransform="uppercase">Price</Text>
                                          <Text fontSize="2xl" fontWeight="bold" color={colorMain} lineHeight="1">
                                              {(selectedTargets.amount * quantity).toLocaleString()}
                                          </Text>
                                      </Flex>
                                      <Flex flexDir="column" alignItems="flex-end">
                                          <Text fontSize="xs" fontWeight="bold" color="gray.500" mb={2} textTransform="uppercase">Quantity</Text>
                                          <Flex
                                              alignItems="center"
                                              border="1px solid"
                                              borderColor="gray.200"
                                              borderRadius="lg"
                                              bg="white"
                                              overflow="hidden"
                                              h="40px"
                                          >
                                              <Button
                                                  size="sm"
                                                  onClick={() => setQuantity(q => Math.max(1, q - 1))}
                                                  variant="ghost"
                                                  borderRadius="none"
                                                  _hover={{ bg: 'gray.50' }}
                                                  h="100%"
                                                  w="40px"
                                                  fontSize="xl"
                                                  fontWeight="medium"
                                                  color="gray.600"
                                                  isDisabled={quantity <= 1}
                                              >-</Button>
                                              <Input
                                                  type="number"
                                                  variant="unstyled"
                                                  value={quantity}
                                                  onChange={(e) => setQuantity(Math.max(1, parseInt(e.target.value) || 1))}
                                                  min={1}
                                                  textAlign="center"
                                                  w="50px"
                                                  fontSize="lg"
                                                  fontWeight="semibold"
                                                  color={colorMain}
                                              />
                                              <Button
                                                  size="sm"
                                                  onClick={() => setQuantity(q => q + 1)}
                                                  variant="ghost"
                                                  borderRadius="none"
                                                  _hover={{ bg: 'gray.50' }}
                                                  h="100%"
                                                  w="40px"
                                                  fontSize="xl"
                                                  fontWeight="medium"
                                                  color="gray.600"
                                              >+</Button>
                                          </Flex>
                                      </Flex>
                                  </Flex>
                              )}
                            </>
                          ) : detailTo && ["tiles", "linear_scale", "rating"].includes(detailTo) ? (
                            <Box mb={8}>
                              <FormLabel fontSize="lg" fontWeight="medium" color="gray.600" mt={2}>
                                &nbsp;{" "}
                                {data?.data.saledata?.sale_settings?.pay_detail_button_name || (detailTo === "rating" ? "Rating" : "Select")}
                              </FormLabel>
                              {detailTo === "rating" ? (
                                <Flex gap={2}>
                                  {[1, 2, 3, 4, 5].map((star) => (
                                    <Box
                                      key={star}
                                      as="button"
                                      onClick={() => !selectedOption && setSelection(star.toString())}
                                      _hover={!selectedOption ? { transform: "scale(1.1)" } : {}}
                                      transition="all 0.2s"
                                      cursor={selectedOption ? "default" : "pointer"}
                                    >
                                      {parseInt(selection || "0") >= star ? (
                                        <FaStar size={32} color="#ECC94B" />
                                      ) : (
                                        <FaRegStar size={32} color="#CBD5E0" />
                                      )}
                                    </Box>
                                  ))}
                                </Flex>
                              ) : (
                                <Flex gap={detailTo === "tiles" ? 4 : 2} wrap="wrap">
                                  {(urlOptions.length > 0 ? urlOptions.map(o => o.value) : ["1", "2", "3", "4", "5"]).map((opt) => (
                                    <Button
                                      key={opt}
                                      onClick={() => !selectedOption && setSelection(opt)}
                                      colorScheme={selectedCategory === opt ? "teal" : "gray"}
                                      variant={selectedCategory === opt ? "solid" : "outline"}
                                      size={detailTo === "tiles" ? "lg" : "md"}
                                      width={detailTo === "tiles" ? "auto" : "40px"}
                                      height={detailTo === "tiles" ? "auto" : "40px"}
                                      minH={detailTo === "tiles" ? "60px" : "auto"}
                                      px={detailTo === "tiles" ? 6 : 0}
                                      py={detailTo === "tiles" ? 4 : 0}
                                      isDisabled={selectedOption}
                                    >
                                      {opt}
                                    </Button>
                                  ))}
                                </Flex>
                              )}
                              {detailTo !== "rating" && subCategoryOptions.length > 0 && (
                                <Box mt={4}>{renderSubCategorySelect()}</Box>
                              )}
                            </Box>
                          ) : detailTo && ["text", "paragraph", "short_answer", "date", "time", "datetime"].includes(detailTo) ? (
                            <>
                              <FormLabel fontSize="lg" fontWeight="medium" color="gray.600" mt={2}>
                                &nbsp;{" "}
                                {data?.data.saledata?.sale_settings
                                  ?.pay_detail_button_name || "Description"}
                              </FormLabel>

                              {["paragraph", "text"].includes(detailTo) ? (
                                <Textarea
                                  border="1px solid"
                                  borderColor={colorMain}
                                  placeholder="Enter payment details here"
                                  value={selection}
                                  onChange={(e) => setSelection(e.target.value)}
                                  isReadOnly={selectedOption}
                                  required
                                />
                              ) : (
                                <DynamicInput
                                  border="1px solid"
                                  borderColor={colorMain}
                                  type={detailTo === "datetime" ? "datetime-local" : detailTo === "short_answer" ? "text" : detailTo}
                                  placeholder="Enter payment details here"
                                  value={selection}
                                  onChange={(e) => setSelection(e.target.value)}
                                  required
                                  isReadOnly={selectedOption}
                                />
                              )}
                            </>
                          ) : detailTo && ["options", "checkboxes"].includes(detailTo) ? (
                            urlOptions?.length && (
                              <>
                                <FormLabel
                                  fontSize="lg"
                                  mt={2}
                                  ml={-2}
                                  fontWeight="bold"
                                >
                                  &nbsp;{" "}
                                  {data?.data.saledata?.sale_settings
                                    ?.pay_detail_button_name || "Select"}
                                </FormLabel>
                                <Text fontSize="lg" ml={2} fontFamily="poppins">
                                  Select one or multiple categories to proceed
                                </Text>

                                <OptionsWithCheckboxes
                                  urlOptions={urlOptions}
                                  colorMain={colorMain}
                                  setSelectionDetails={setSelectionDetails}
                                  setIsSelectButtonDisabled={
                                    setIsSelectButtonDisabled
                                  }
                                  setTotalSplitAmountB={setTotalSplitAmountB}
                                  amount={amount}
                                  setAmount={setAmount}
                                  toast={toast}
                                  setAnyChecked={setAnyChecked}
                                  isCheckedAanyChecked={isCheckedAanyChecked}
                                  totalSplitAmountB={totalSplitAmountB}
                                  urlOption={urlOption}
                                  isDisabled={selectedOption}
                                  quantityButtonVisible={
                                    data?.data?.saledata?.sale_settings
                                      ?.quantity_button_visible === true
                                  }
                                />
                              </>
                            )
                          ) : (
                            <></>
                          )
                        ) : (
                          <></>
                        )}
                      </FormControl>
                    </FadeIn>
                    {/* )} */}
                  </ModalBody>

                  <ModalFooter
                    align="center"
                    justify="center"
                    display="flex"
                    flexDir="column"
                  >
                    {!amount || amount < 1 ? (
                      <Tooltip
                        label="Please enter the amount to pay"
                        fontSize="lg"
                      >
                        <Button
                          onClick={() => setOnPayClick(true)}
                          bgColor={colorMain}
                          color="white"
                          align="center"
                          p="18px"
                          borderRadius="3px"
                          fontWeight="bold"
                          mb={6}
                          w="100%"
                          px={16}
                          fontSize="xl"
                        >
                          {payType === "card" ? "Go to Payment Page" : getActionWord(templateType)}
                        </Button>
                      </Tooltip>
                    ) : (
                      <PayButton
                        colorMain={colorMain}
                        number={number}
                        phoneLength={phoneLength}
                        amount={amount}
                        name={isChecked ? "Anonymous" : name}
                        buttone={buttone}
                        selection={["options", "checkboxes"].includes(detailTo) ? true : needsSubCategory ? "" : selection}
                        buttonDisable={buttonDisable}
                        isAddButtonDisabled={isAddButtonDisabled || (idtagRequired && !idTag?.trim()) || (registeredOnly && !isRegisteredMember)}
                        isSelectButtonDisabled={isSelectButtonDisabled}
                        trigger={trigger}
                        handlePayment={handlePayment}
                        nameOption={nameOption}
                        buttonText={payType === "card" ? "Go to Payment Page" : getActionWord(templateType)}
                      />
                    )}
                  </ModalFooter>
                </ModalContent>
              </>
            )
            }{" "}
          </>
        ) : (
          <>
            {!subActive ? (
              <ModalContent mb="300">
                <ModalCloseButton />
                <ModalBody p={9} fontSize="xl">
                  <Text>
                    Plan for this collection is not active. The Plan has expired
                    or number of contibutors has been exceeded. Contact the
                    organizer to renew or upgrade the plan. We apologize for the
                    inconvenience.
                  </Text>
                </ModalBody>
              </ModalContent>
            ) : (
              <ModalContent>
                <ModalCloseButton />
                <ModalHeader mt={3} textAlign="center" color={colorMain}>
                  Pledge to contribute
                </ModalHeader>
                <ModalBody pb={6}>
                  <FormControl>
                    <Flex
                      // shadow="base"
                      borderRadius="10px"
                      flexDir="column"
                      px={3}
                      pt={4}
                      height="fit-content"
                    >
                      <Text fontWeight="bold" fontSize="1.8rem" pb={0} mb={0}>
                        Enter Amount
                      </Text>
                      {(() => {
                        const pledgeAmountLength = String(pledgeAmount || "").length;
                        const pledgeAmountFontSize =
                          pledgeAmountLength > 12
                            ? "2xl"
                            : pledgeAmountLength > 9
                              ? "4xl"
                              : pledgeAmountLength > 6
                                ? "5xl"
                                : "7xl";
                        return (
                      <Flex
                        pb={amountBlank ? 0 : 2}
                        alignItems="baseline"
                        ml={
                          !pledgeAmount || pledgeAmount?.length < 1
                            ? "12"
                            : pledgeAmount?.length > 4
                              ? pledgeAmount?.length - 2
                              : "16"
                        }
                        justifyContent="center"
                        fontWeight="semibold"
                      >
                        <span
                          style={{
                            color: "#878787",
                            fontWeight: "lighter",
                            fontSize: "18px",
                            marginRight: "3px",
                          }}
                        >
                          KES
                        </span>
                        <Input
                          ref={initialRef}
                          type="number"
                          variant="unstyled"
                          fontSize={[pledgeAmountFontSize, pledgeAmountFontSize]}
                          placeholder={!pledgeAmount ? "0.00" : ""}
                          value={pledgeAmount}
                          onChange={(e) => setPledgeAmount(e.target.value)}
                          required
                          color={colorMain}
                          fontWeight="semibold"
                        // borderBottom="1px solid black"
                        />
                      </Flex>
                        );
                      })()}
                      {amountBlank && (
                        <Flex
                          p={0}
                          pb={2}
                          m={0}
                          alignItems="center"
                          justifyContent="center"
                        >
                          <FormHelperText p={0} m={0} color="red" fontSize="xl">
                            Amount must be greater than 0.
                          </FormHelperText>
                        </Flex>
                      )}
                    </Flex>
                  </FormControl>
                  <FormControl mt={8} isRequired fontSize="xl">
                    <Heading fontSize="lg" fontWeight="semibold" my={4}>
                      Make a pledge to contribute
                    </Heading>

                    <FormLabel fontSize="lg" fontWeight="medium" color="gray.600">
                      &nbsp; Phone number
                    </FormLabel>
                    <DynamicInput
                      mb={8}
                      type="text"
                      placeholder="Enter number here"
                      value={pledgeNumber}
                      onChange={(e) => {
                        const { number, length } = handleInputPledge(e);
                        setPledgeNumber(number);
                        setPhoneLength(length);
                      }}
                      required
                    />

                    {registeredOnly &&
                      pledgeNumber?.length === phoneLength &&
                      !disabled &&
                      !isRegisteredPledgeMember && (
                        <FormHelperText
                          textAlign="center"
                          color="red.500"
                          fontSize="sm"
                          m={0}
                          mb={4}
                        >
                          {NOT_REGISTERED_MESSAGE}
                        </FormHelperText>
                      )}

                    {pledgeNumber?.length === phoneLength && (
                      <FadeIn>
                        <FormLabel fontSize="lg" fontWeight="medium" color="gray.600">
                          &nbsp; Name
                        </FormLabel>
                        <DynamicInput
                          mb={8}
                          type="text"
                          placeholder={!customerName ? "Enter name here" : ""}
                          value={customerName}
                          onChange={(e) => setCustomerName(e.target.value)}
                          required
                          isDisabled={disabled}
                        />
                      </FadeIn>
                    )}

                    {buttone ? (
                      // Pledges always use the dropdown selector for categories,
                      // regardless of the pay_detail_type style configured for regular payments
                      // (e.g. checkboxes never populate `selection`, which left the pledge
                      // button permanently disabled).
                      <>
                        <FormLabel fontSize="lg" fontWeight="medium" color="gray.600" mt={2}>
                          &nbsp;{" "}
                          {data?.data.saledata?.sale_settings
                            ?.pay_detail_button_name || "Select"}
                        </FormLabel>

                        <DynamicSelectInput
                          mb={8}
                          options={urlOptions}
                          condition={selectedOption}
                          value={selectedCategory}
                          onChange={(e) => setSelection(e.target.value)}
                          required
                        />
                        {renderSubCategorySelect()}
                      </>
                    ) : (
                      <></>
                    )}
                  </FormControl>
                  <Flex
                    align="center"
                    justify="center"
                    display="flex"
                    flexDir="column"
                  >
                    <ActionButton
                      onClick={handlePledgeContribution}
                      text={`Pledge Amount`}
                      isLoading={trigger}
                      isDisabled={
                        pledgeNumber?.length === phoneLength &&
                          pledgeAmount > 0 &&
                          customerName &&
                          buttonDisable(buttone, needsSubCategory ? "" : selection) &&
                          (!registeredOnly || isRegisteredPledgeMember)
                          ? false
                          : true
                      }
                      colorMain={colorMain}
                      spinnerColor="teal"
                    />
                  </Flex>
                </ModalBody>
              </ModalContent>
            )}
          </>
        )}
      </Modal >
    );
  }
);

export default DynamicDrawer;
